<template>
	<PageDefault size="narrow">
		<h1>Вхід до кабінету</h1> 
		<p>Кабінет дозволяє вам керувати власними станціями моніторингу</p>
	
		<PanelNote>
			<template #icon>
				<FontAwesomeIcon :icon="faTriangleExclamation" style="font-size: x-large; padding-right: 0.5em"/>
			</template>
			<template #title>
				Зареєстровані користувачі
			</template>
			<template #description>
				Якщо ви були зареєстровані на сайті старої версії, вам
				треба <router-link to="/password-recovery">відновити пароль</router-link>
				перед тим, як входити в акаунт.
			</template>
		</PanelNote>

		<br>

		<small v-show="showInvalid" style="color: var(--color-bad)">Перевірте правильність введених даних</small>
		
		<div class="flex flex-col gap-2">
			<input 
				v-model="email" 
				type="text" 
				placeholder="Введіть ваш e-mail" 
				class="text-box"
				:class="{ invalid: !isEmailValid(email) && showInvalid }"
				@keyup.enter="passwordInput.focus()"
			>
			<input 
				v-model="password" 
				type="password" 
				placeholder="Введіть ваш пароль" 
				class="text-box"
				ref="passwordInput"
				@keyup.enter="enterButton.click()"
			>
		</div>
		
		<div style="padding-top: 0.5em;">
			<button 
				class="btn" 
				@click="enterButtonClick()"
				ref="enterButton"
			>
				Вхід
				<FontAwesomeIcon :icon="faRightToBracket"/>
			</button>
		</div>
	
		<div style="display: flex; justify-content: center;">
			<p>
				<router-link to="/register">Зареєструватись</router-link> / 
				<router-link to="/password-recovery">Відновити пароль</router-link>
			</p>
			<br>
		</div>
	
		<div class="loginProviders" style="display: flex; justify-content: center;">
			<GoogleLogin :callback="googleLoginCallback">
				<button>
					<FontAwesomeIcon :icon="faGoogle"/>
					Увійти через Google
				</button>
			</GoogleLogin>
		</div>
	
		<br/>
	</PageDefault>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'

import PageDefault from '@/components/ui/PageDefault.vue'
import PanelNote from '@/components/ui/PanelNote.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faGoogle } from '@fortawesome/free-brands-svg-icons'
import { faRightToBracket } from '@fortawesome/free-solid-svg-icons'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'

import { User } from '@/state/User.js'
import { isEmailValid } from '@/modules/DataValidation'

const router = useRouter()

const passwordInput = ref(null)
const enterButton = ref(null)

const email = ref("")
const password = ref("")

const showInvalid = ref(false)

async function googleLoginCallback(response) {
	console.log("Handle the response", response)

	if (await User.loginGoogle(response.code)) {
		router.push({ name: 'cabinet' })
	} else {
		window.alert("Не вдалось увійти.")
	}
}

async function enterButtonClick() {
	if (!isEmailValid(email.value)) {
		showInvalid.value = true
		return
	}

	console.log("LOGIN RUN")

	if (await User.login(email.value, password.value)) {
		router.push({ name: 'cabinet' })
	} else {
		window.alert("Не вдалось увійти. Можливо ви ввели неправльний логін і пароль.")
	}
}

watch(User, () => {
	if (User.isAuthenticated()) {
		router.push({ name: 'cabinet' })
	}
})

watch(email, () => {
	if (showInvalid.value && isEmailValid(email.value)) showInvalid.value = false
})

onMounted(() => {
	if (router.currentRoute.value.query.token) {
		console.log("CONFIRM EMAIL")
		console.log(router.currentRoute.value.query.token)
		User.confirmEmail(router.currentRoute.value.query.token)
	}
})
</script>

<style scoped>

.dark .text-box.invalid {
	background-color: #7c2f2f;
}

.text-box.invalid {
	background-color: #d47272;
}
</style>